import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  template: `
    <div>アクセス権がありません。</div>
  `,
  styles: ['div { margin-top: 20px; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UnauthorizedComponent {}
